import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import React, {lazy, Suspense} from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {NextUIProvider, Spinner} from "@nextui-org/react";
import {GoogleOAuthProvider} from "@react-oauth/google";
import Login from "./components/auth/Login";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import {Header, NewDashboards} from "./pagesAfterLogin";

const GOOGLE_CLIENT_ID = "756495051238-po29f1hscq7j6h9b6qhv85r5kmb19t39.apps.googleusercontent.com";

// Every page except Login is loaded on demand, so the login screen downloads only what it needs
const ClubListInUserDistrict = lazy(() => import("./components/admin/clubs/ClubListInUserDistrict"));
const Ambassadorial = lazy(() => import("./components/admin/Ambassadorial/Ambassadorial"));
const Meetings = lazy(() => import("./components/admin/Meetings/Meetings"));
const Finances = lazy(() => import("./components/admin/Finances/Finances"));
const Membership = lazy(() => import("./components/admin/Membership/Membership"));
const Projects = lazy(() => import("./components/admin/projects/Projects"));
const EdgeCard = lazy(() => import("./components/admin/PriviledgeCards/EdgeCard"));
const ViewNominations = lazy(() => import("./components/admin/aaras/ViewNominations"));
const NewNominationForProjects = lazy(() => import("./components/admin/aaras/NewNominationForProjects"));
const ViewNominationsForDistrictAdmin = lazy(() => import("./components/admin/aaras/ViewNominationsForDistrictAdmin"));
const Questionnaire = lazy(() => import("./components/council57/Questionnaire"));
const ThankYouPage = lazy(() => import("./components/council57/ThankYouPage"));
const ApplicationResponses = lazy(() => import("./components/council57/ApplicationResponses"));
const IndividualApplications = lazy(() => import("./components/council57/IndividualApplications"));
const EditMemberData = lazy(() => import("./components/admin/Membership/EditMemberData"));
const MembershipStepper = lazy(() => import("./components/admin/Membership/AddNew/MembershipStepper"));
const ReportAmbassadorial = lazy(() => import("./components/admin/Ambassadorial/ReportAmbassadorial"));
const ViewReportAmbassadorial = lazy(() => import("./components/admin/Ambassadorial/ViewReportAmbassadorial"));
const ReportMeetings = lazy(() => import("./components/admin/Meetings/ReportMeetings"));
const ViewReportMeetingMinutes = lazy(() => import("./components/admin/Meetings/ViewReportMeetingMinutes"));
const ViewReportProject = lazy(() => import("./components/admin/projects/ViewReportProject"));
const NewNominationForIndividualAwards = lazy(() => import("./components/admin/aaras/NewNominationForIndividualAwards"));
const ReportProject = lazy(() => import("./components/admin/projects/ReportProject"));
const OnBoardNewClubAndOfficers = lazy(() => import("./components/admin/clubs/OnBoardNewClubAndOfficers"));
const DistrictAdmin = lazy(() => import("./components/admin/HomeDistrictAdmin/DistrictAdmin"));
const Dashboard = lazy(() => import("./components/admin/dashboard/Dashboard"));

export function PageLoader() {
    return (
        <div className="flex min-h-[50vh] items-center justify-center">
            <Spinner color="danger" label="Loading..."/>
        </div>
    );
}

function App() {

    return (
        <NextUIProvider>
            <BrowserRouter>
                <Suspense fallback={<PageLoader/>}>
                <Routes>
                    {/* Only the login page signs in with Google, so only it loads Google's sign-in script */}
                    <Route exact path="/" element={
                        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                            <Login/>
                        </GoogleOAuthProvider>
                    }/>
                    <Route path="/pranali" element={
                        <ProtectedRoute>
                            <Header/>
                        </ProtectedRoute>
                    }>
                        <Route exact path="" element={<NewDashboards/>}/>

                        <Route path="membership">
                            <Route exact path="" element={<Membership/>}/>
                            <Route path="edit" element={<EditMemberData/>}/>
                            <Route path="new" element={<MembershipStepper/>}/>
                        </Route>
                        <Route path="finances" element={<Finances/>}/>
                        <Route path="projects">
                            <Route exact path="" element={<Projects/>}/>
                            <Route path="new-report" element={<ReportProject/>}/>
                            <Route path="view-report" element={<ViewReportProject/>}/>
                            <Route path="edit-report" element={<ReportProject/>}/>
                        </Route>
                        <Route path="meetings">
                            <Route exact path="" element={<Meetings/>}/>
                            <Route path="new-report" element={<ReportMeetings/>}/>
                            <Route path="view-report" element={<ViewReportMeetingMinutes/>}/>
                            <Route path="edit-report" element={<ReportMeetings/>}/>
                        </Route>
                        <Route path="ambassadorials">
                            <Route exact path="" element={<Ambassadorial/>}/>
                            <Route path="new-report" element={<ReportAmbassadorial/>}/>
                            <Route path="view-report" element={<ViewReportAmbassadorial/>}/>
                            <Route path="edit-report" element={<ReportAmbassadorial/>}/>
                        </Route>
                        <Route path="clubs-3142">
                            <Route exact path="" element={<ClubListInUserDistrict/>}/>
                            <Route exact path="view-club-insights" element={<Dashboard/>}/>
                            <Route path="onboard-new" element={<OnBoardNewClubAndOfficers/>}/>
                        </Route>
                        <Route path="administration">
                            <Route exact path="" element={<DistrictAdmin/>}/>
                        </Route>
                        <Route path="aara">
                            <Route exact path="" element={<ViewNominations/>}/>
                            <Route path="new-nomination-projects" element={<NewNominationForProjects/>}/>
                            <Route path="new-nomination-individual" element={<NewNominationForIndividualAwards/>}/>
                            <Route path="view-nominations-district-admin" element={<ViewNominationsForDistrictAdmin/>}/>
                        </Route>
                        <Route path="council58-applications">
                            <Route exact path="" element={<ApplicationResponses/>}/>
                            <Route path="view" element={<IndividualApplications/>}/>
                        </Route>
                        <Route path="discounts" element={<EdgeCard/>}/>
                    </Route>
                    <Route path="/council58" element={<Questionnaire/>}/>
                    <Route path="/thankyou" element={<ThankYouPage/>}/>
                </Routes>
                </Suspense>
            </BrowserRouter>
        </NextUIProvider>
    );
}

export default App;
